import {
  ForgotEmailPopup,
  SignInForm,
  SignInFormData,
} from '@features/user/auth';
import { useCallback, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { adminSignIn } from '@src/services/auth';
import { useAuthStore } from '@src/stores/authStore';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export const AdminSignInPage = () => {
  const { t } = useTranslation();
  const [openForgotEmail, setOpenForgotEmail] = useState(false);
  const { auth } = useAuthStore();

  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = useCallback(
    async (data: SignInFormData) => {
      try {
        const res = await adminSignIn({
          ...data,
          login: data.login.toLowerCase(),
        });

        auth.setAccessToken(res.data.token);

        const fromPathname = (location.state as any)?.from?.pathname as
          | string
          | undefined;

        navigate(fromPathname?.startsWith('/admin') ? fromPathname : '/admin', {
          replace: true,
        });
      } catch {
        toast.error(t('toast.failedToLogin'));
      }
    },
    [auth, location.state, navigate, t]
  );

  return (
    <>
      <SignInForm
        hideRedirectToSignUp
        className={'bg-[#242C36]'}
        onOpenForgotEmail={() => setOpenForgotEmail(true)}
        onOpenForgotPassword={() => navigate('/admin/forgot-password')}
        onSubmit={handleLogin}
      />
      <ForgotEmailPopup
        open={openForgotEmail}
        onOpenChange={(val) => setOpenForgotEmail(val)}
      />
    </>
  );
};
